export const resolve = (path: string, obj: any) => {
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : ''
  }, obj)
}

export const parseBool = (s: any) => String(s).toLowerCase() === 'true'
